module.exports = __webpack_public_path__ + "img/arrow_up_green.362dd9ea.svg";